import { HttpClient } from '#client/http/index'
import {
  ListActivityRankingsResponse,
  ActivityId,
  GetActivityFacilityRankingResponse,
} from '#client/resources/index'
import { ApiResponse } from '#client/resources/types'

export const listActivityRankings = async ({
  httpClient,
}: {
  httpClient: HttpClient
}) => {
  const { data }: ApiResponse<ListActivityRankingsResponse> =
    await httpClient.get(`/user/ranking/activities`)

  return data
}

export const getActivityFacilityRanking = async (
  {
    httpClient,
  }: {
    httpClient: HttpClient
  },
  activityId: ActivityId,
) => {
  const { data }: ApiResponse<GetActivityFacilityRankingResponse> =
    await httpClient.get(`/user/ranking/facilitiesByActivity/${activityId}`)

  return data
}
